import { ref } from 'vue';

export function useCsvExportModal() {
  const csvExportWithDateRangeModal = ref(false);
  const csvExportWithDateRangeModal_type = ref('');
  const csvExportWithDateRangeModal_title = ref('');
  const downloadID = ref('');
  const fileName = ref('');

  function csvExportWithDateRangeModal_open(
    id: string,
    name: string,
    value: string,
    file: string,
  ) {
    csvExportWithDateRangeModal_type.value = id;
    csvExportWithDateRangeModal_title.value = name;
    downloadID.value = value;
    fileName.value = file;
    csvExportWithDateRangeModal.value = true;
  }

  return {
    csvExportWithDateRangeModal,
    csvExportWithDateRangeModal_type,
    csvExportWithDateRangeModal_title,
    downloadID,
    fileName,
    csvExportWithDateRangeModal_open,
  };
}
